export default __webpack_public_path__ + "static/media/level-2.68078589.png";